<template>
  <v-app id="inspire">
    <div class="clients-wrap">
      <v-layout>
        <v-flex>
          <h2 class="headline">Schedule
            <v-menu v-if="permissions.includes('schedule_map_view')" offset-y bottom right>
              <template v-slot:activator="{ on }">
                <v-btn
                  class="ml-3 mb-3 text-none"
                  elevation="0"
                  v-on="on"
                  small
                >Table View <v-icon>arrow_drop_down</v-icon>
                </v-btn>
              </template>
              <v-list class="py-0">
                <v-list-item 
                  class="v-list-item--active primary--text"
                  @click="$router.push(`/schedule/map_view`)"
                >
                  <v-list-item-title>Map View</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </h2>
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn
          class="ma-0 text-none"
          text
          small
          :loading="loadingCSV"
          :disabled="loadingCSV"
          @click="downloadCSV"
        ><v-icon class="mr-1">cloud_download</v-icon> CSV <!-- Master Schedule CSV -->
        </v-btn>
      </v-layout>
      <div class="header-search-single">
        <v-layout class="wrap">
          <v-flex class="md7 xs12">
            <v-layout>
              <v-text-field
                class="inv-search-field"
                append-icon="search"
                label="Search"
                single-line
                hide-details
                v-model="search"
                @input="typing = true"
              >
              </v-text-field>
              <v-btn
                v-if="!showFilters"
                text
                class="mt-4 mx-2 px-2 dialog-btn"
                @click="showFilters = !showFilters"
                ><v-icon class="mr-2">filter_list</v-icon>
                <span style="text-transform: none; color: #00838F"
                  >Show Filters</span
                ></v-btn
              >
              <template v-else>
                <v-btn
                  text
                  class="mt-4 mx-2 px-2 dialog-btn"
                  @click="showFilters = !showFilters"
                  ><v-icon class="mr-2">filter_list</v-icon>
                  <span style="text-transform: none; color: #00838F;"
                    >Hide Filters</span
                  ></v-btn
                >
              </template>
            </v-layout>
          </v-flex>
          <v-container v-if="showFilters" class="grid-list-md pa-0 mx-0 mb-4">
            <v-layout xs12 class="mt-2 xs12 wrap">
              <v-flex class="xs12 md6 lg2" style="min-width: 300px;">
                <v-autocomplete
                  :items="staff"
                  v-model="tableData.assigned_to"
                  :loading="loadingStaff"
                  label="Select Staff Name"
                  placeholder="Please Select"
                  item-text="name"
                  item-value="id"
                ></v-autocomplete>
              </v-flex>
              <v-flex class="xs12 md6 lg2" style="min-width: 300px;">
                <v-autocomplete
                  :items="frequencies"
                  v-model="tableData.service_plan_slug"
                  :loading="loadingFrequencies"
                  label="Service Frequency"
                  placeholder="Please Select"
                  item-text="text"
                  item-value="value"
                ></v-autocomplete>
              </v-flex>
              <v-flex class="xs12 md6 lg2" style="min-width: 170px;">
                <v-checkbox
                  :class="{ 'mt-0': $vuetify.breakpoint.smAndDown }"
                  true-value="1"
                  false-value="0"
                  v-model="tableData.show_one_time"
                  :label="`Show One Time Cleanups`"
                ></v-checkbox>
              </v-flex>
              <v-flex class="xs12 md2">
                <v-btn
                  large
                  color="primary"
                  class="mx-0 mt-1 mb-2"
                  style="min-width: 50px; padding: 0 10px;"
                  @click="initialize(true)"
                  >Go</v-btn
                >
              </v-flex>
            </v-layout>
            <v-layout v-if="showFilters" class="xs12">
              <v-flex style="max-width: 100px;">
                <span
                  class="mt-0 ml-0 clear-filters"
                  @click="clearFilters"
                  >Clear Filters</span
                >
              </v-flex>
            </v-layout>
          </v-container>
          <v-flex class="mt-3">
            <v-layout>
              <v-spacer></v-spacer>
              <v-menu offset-y bottom left>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" color="primary" class="mr-0 ml-1 px-4">
                    Actions <v-icon right>keyboard_arrow_down</v-icon>
                  </v-btn>
                </template>
                <v-list style="cursor: pointer;">
                  <v-list-item @click="massTechReassignModal">
                    <v-list-item-title
                      ><v-icon color="success" class="mr-2">swap_horiz</v-icon>
                      Change Tech</v-list-item-title
                    >
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-layout>
          </v-flex>
        </v-layout>
      </div>
      <!-- Edit Dialog Wiew  -->
      <v-card>
        <!-- tools table -->
        <v-data-table
          :headers="headers"
          :items="items"
          :options.sync="options"
          :server-items-length="totalItems"
          :loading="loading"
          loader-height="2"
          :footer-props="{'items-per-page-options': [10, 20]}"
          class="elevation-1 table-org my-sticky-last-column-table"
          :header-props="{ 'sort-icon': 'arrow_downward' }"
          mobile-breakpoint="100"
        >
          <template v-slot:item="{item}">
            <tr class="items-body-row">
              <td>
                <router-link
                  :to="'/schedule/' + item.id + '/show'"
                  >{{ item.id }}</router-link
                >
              </td>
              <td>
                <router-link
                  :to="!Boolean(item.commercial) ? 
                    `/client/${item.client_id}/show` :
                    `/commercial_client/${item.commercial_client_id}/show?commercial_location_id=${item.commercial_location_id}`"
                  >{{ item.full_name }}</router-link
                >
              </td>
              <td>{{ item.address }}</td>
              <td>{{ item.city }}</td>
              <td>{{ item.zip }}</td>
              <td>{{ item.assigned_to_name }}</td>
              <td>
                {{ formatTitle(item.service_plan_slug) }}
              </td>
              <td>
                <v-flex d-flex style="max-width: 72px; margin: 0 auto;">
                  <v-btn icon class="mx-0" @click="showDetails(item.id)">
                    <v-icon color="primary">visibility</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    class="mx-0"
                    @click="
                      assignLocationModal(
                        item.id,
                        item.service_plan_name
                      )
                    "
                  >
                    <v-icon color="green">create</v-icon>
                  </v-btn>
                </v-flex>
              </td>
            </tr>
          </template>
          <template
            slot="no-data"
            v-if="error_code == 404 || error_code == 500"
          >
            <v-btn color="primary" @click="initialize()">Reset</v-btn>
          </template>
        </v-data-table>

        <edit-unassigne-schedule @done="initialize"></edit-unassigne-schedule>
      </v-card>

      <!-- Mass Tech Reassign Dialog -->
      <v-dialog v-model="massTechReassignDialog" max-width="500px" persistent>
        <v-card class="pa-4">
          <v-card-title>
            <h2 class="title">Change Tech</h2>
          </v-card-title>
          <div class="py-4 px-6">
            <v-alert
              class="pa-2 mt-0 mb-6"
              outlined
              color="info"
              icon="info"
            >
              <span
                >After you change tech, all client locations and dispatched jobs
                will be reassigned to new tech.</span
              >
            </v-alert>
            <v-flex class="xs12">
              <v-select
                :items="staff"
                v-model="massTechReassignData.selected_staff_id_from"
                label="From"
                item-text="name"
                item-value="id"
                :error-messages="
                  errors($v.massTechReassignData.selected_staff_id_from)
                "
                @blur="$v.massTechReassignData.selected_staff_id_from.$touch()"
                @change="
                  $v.massTechReassignData.selected_staff_id_from.$touch()
                "
                placeholder="Please Select Tech"
              ></v-select>
            </v-flex>
            <v-flex class="xs12">
              <v-select
                :items="filteredStaff"
                v-model="massTechReassignData.selected_staff_id_to"
                label="To"
                item-text="name"
                item-value="id"
                :error-messages="
                  errors($v.massTechReassignData.selected_staff_id_to)
                "
                @blur="$v.massTechReassignData.selected_staff_id_to.$touch()"
                @change="$v.massTechReassignData.selected_staff_id_to.$touch()"
                placeholder="Please Select Tech"
              ></v-select>
            </v-flex>

            <v-alert
              class="pa-2 mt-4"
              :value="$v.massTechReassignData.$error"
              outlined
              color="error"
              icon="priority_high"
              transition="scale-transition"
            >
              <span class="caption">Please fill out all required fields</span>
            </v-alert>
            <v-alert
              class="pa-2 mt-4"
              :value="!serverValidation"
              outlined
              color="error"
              icon="priority_high"
              transition="scale-transition"
            >
              <span class="caption">{{ serverValidationMessage }}</span>
            </v-alert>
          </div>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="closeMassTechReassign"
              >Cancel</v-btn
            >
            <v-btn
              color="primary"
              :loading="massTechReassignLoading"
              :disabled="massTechReassignLoading"
              @click="massTechReassign"
              >Save</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-app>
</template>

<script>
import ApiService from "@/common/api.service";
import EditUnassigneSchedule from "../EditUnassigneSchedule.vue";
import { validationMixin } from "vuelidate";
import { required, decimal, helpers, numeric } from "vuelidate/lib/validators";
import { valMessages, getValMessage } from "@/common/error-messages";
import { mapGetters, mapActions } from 'vuex';

const validations = {
  massTechReassignData: {
    selected_staff_id_from: { required },
    selected_staff_id_to: { required }
  }
};

export default {
  name: "Schedule",
  components: {
    EditUnassigneSchedule
  },
  mixins: [validationMixin],
  validations,
  data: () => ({
    error_code: "",
    no_data: [null, "", undefined, "null"],
    showFilters: false,
    headers: [
      { text: "Location ID", value: "id", sort_column: 0 },
      { text: "Client Name", value: "full_name", sort_column: 1 },
      { text: "Address", value: "address", sortable: false },
      { text: "City", value: "city", sortable: false },
      { text: "Zip", value: "zip", sortable: false },
      {
        text: "Cleanup Assigned To",
        value: "assigned_to_name",
        sortable: false
      },
      {
        text: "Service Frequency",
        value: "service_plan_slug",
        sortable: false
      },
      { text: "Actions", sortable: false, align: "center" }
    ],
    items: [],
    totalItems: 0,
    search: "",
    options: {},
    loading: false,
    draw: 0,
    show_all_clients: false,
    tableData: {
      draw: 0,
      length: 10,
      search: "",
      page: 0,
      column: 0,
      dir: "asc",
      show_one_time: 0
    },
    service_plan: "",
    staff: [],
    loadingStaff: false,
    frequencies: [],
    loadingFrequencies: false,
    days: {
      "1": { name: "Monday", short: "Mon" },
      "2": { name: "Tuesday", short: "Tue" },
      "3": { name: "Wednesday", short: "Wed" },
      "4": { name: "Thursday", short: "Thu" },
      "5": { name: "Friday", short: "Fri" },
      "6": { name: "Saturday", short: "Sat" },
      "7": { name: "Sunday", short: "Sun" }
    },

    massTechReassignDialog: false,
    massTechReassignData: {},
    massTechReassignLoading: false,

    serverValidation: true,
    serverValidationMessage: "Oops something went wrong...",
    loadingCSV: false
  }),

  watch: {
    options: {
      handler() {
        if (this.draw !== this.tableData.draw) {
          this.initialize().then(data => {
            this.items = data.items;
            this.totalItems = data.total;
          });
        }
      },
      deep: true
    },
    search: _.debounce(function() {
      this.typing = false;
      if (this.draw !== this.tableData.draw) {
        this.initialize(true).then(data => {
          this.items = data.items;
          this.totalItems = data.total;
        });
      }
    }, 1000)
  },
  mounted() {
    this.initialize()
    this.staffList()
    this.getFrequencies()
  },
  methods: {
    ...mapActions(['vEmit']),
    initialize(firstPage = false) {
      this.loading = true;
      return new Promise((resolve, reject) => {
        const { sortBy, sortDesc, page, itemsPerPage } = this.options;

        this.tableData.column = 0;
        if (
          !this.no_data.includes(sortBy) &&
          !this.no_data.includes(sortBy[0]) &&
          this.headers.some(i => i.value === sortBy[0] && i.sortable !== false)
        ) {
          this.tableData.column = this.headers.find(
            i => i.value === sortBy[0]
          ).sort_column;
        }
        this.tableData.dir = !this.no_data.includes(sortDesc) && sortDesc[0] === true ? "asc" : "desc";

        this.tableData.length = itemsPerPage;
        this.tableData.page = page
        Boolean(this.tableData.show_one_time)
          ? (this.tableData.show_all_clients = true)
          : (this.tableData.show_all_clients = undefined);
        this.tableData.search = this.search;
        this.tableData.draw++;
        this.draw = this.tableData.draw;

        ApiService.get("/scheduler/assigned", this.tableData)
          .then(response => {
            this.items = response.data.locations.data;
            this.totalItems = response.data.locations.total;
            this.draw++;
            if(firstPage) { this.options.page = 1 }
            this.loading = false;

            this.items.forEach(item => {
              if (item.service_plan_slug === null) {
                item.service_plan_slug = "One time";
              }
            });
          })
          .catch(error => {
            this.error_code = error.response.status;
            console.log(error.message);
          });
      });
    },
    clearFilters() {
      this.tableData.assigned_to = null;
      this.tableData.service_plan_slug = null;
      this.show_all_clients = false;
      this.initialize();
    },
    staffList() {
      this.loadingStaff = true;
      ApiService.get("/employee_select_list")
        .then(response => {
          this.staff = response.data.staff;
          this.loadingStaff = false;
        })
        .catch(error => {
          this.loadingStaff = false;
          console.log(error.message);
        });
    },
    getFrequencies() {
      this.loadingFrequencies = true;
      return new Promise((resolve, reject) => {
        ApiService.get("/subscription/get_clean_up_frequency")
          .then(response => {
            let frequencies = response.data.clean_up_frequency;
            frequencies = frequencies.split(",");
            this.frequencies = frequencies.map(i => {
              return { text: this.titleCase(i), value: i };
            });
            this.loadingFrequencies = false;
            resolve();
          })
          .catch(error => {
            this.loadingFrequencies = false
            console.log(error.message)
            reject()
          });
      });
    },
    massTechReassignModal() {
      this.resetServerValidation();
      this.$v.massTechReassignData.$reset();
      this.massTechReassignData = {};
      this.massTechReassignDialog = true;
    },
    massTechReassign() {
      this.resetServerValidation();
      this.$v.massTechReassignData.$touch();
      if (!this.$v.massTechReassignData.$invalid) {
        this.massTechReassignLoading = true;
        let body = { ...this.massTechReassignData };

        ApiService.put("/scheduler/mass_change_tech", body)
          .then(response => {
            this.vEmit({ 
              name: "notification", 
              data: {
                status: "success",
                text: "Tech has been successfully changed."
              }
            });
            this.initialize();
            this.closeMassTechReassign();
            this.massTechReassignLoading = false;
          })
          .catch(({ response }) => {
            this.massTechReassignLoading = false;
            this.serverValidation = false;
            if (response.data.error) {
              this.serverValidationMessage = _.upperFirst(
                res.data.error.replace(/_/g, " ")
              );
            }
          });
      }
    },
    closeMassTechReassign() {
      this.massTechReassignDialog = false;
    },

    showDetails(id) {
      this.$router.push("/schedule/" + id + "/show");
    },

    downloadCSV() {
      this.loadingCSV = true;
      ApiService.get("/scheduler/assigned_export")
        .then(response => {
          let items = response.data.locations;
          let csvContent = ""
          let headers =
            '"Client Name","Client Address","City","State","Zip Code","Subscription Name","Subscription Status","Service Days","Assigned To","Cleanup Frequency","Number Of Dogs"\n';
          let csvData = [];

          items.forEach(i => {
            let formated_service_days = "";
            if (
              !this.no_data.includes(i.service_days) &&
              typeof i.service_days === "string"
            ) {
              formated_service_days = i.service_days
                .split(",")
                .map(i => this.days[i].name)
                .join(", ");
            }

            let row = {
              client_name: `"${i.full_name}"`,
              client_address: `"${i.address}"`,
              city: `"${i.city}"`,
              state: `"${i.state_name}"`,
              zip_code: `"${i.zip}"`,
              service_plan_name: `"${i.service_plan_name}"`,
              status: `"${i.status}"`,
              service_days: `"${formated_service_days}"`,
              assigned_to_name: `"${i.service_tech.split(",").join(', ')}"`,
              service_plan_slug: `"${
                !this.no_data.includes(i.service_plan_slug)
                  ? this.titleCase(i.service_plan_slug)
                  : ""
              }"`,
              number_of_dogs: `"${i.number_of_dogs}"`
            };
            csvData.push(row);
          });

          csvContent += headers;
          csvContent += csvData
            .map(item => Object.values(item).join(","))
            .join("\n");
          csvContent = csvContent.replace(/(^\[)|(\]$)/gm, "");
          const data = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
          const url = URL.createObjectURL(data)
          const link = document.createElement("a");
          link.setAttribute("href", url);
          link.setAttribute("download", `Master Schedule.csv`);
          link.click();

          this.loadingCSV = false;
        })
        .catch(({ response }) => {
          this.loadingCSV = false;
          this.vEmit({ 
            name: "notification", 
            data: {
              status: "error",
              text: "Oops something went wrong..."
            }
          });
        });
    },
    formatTitle(str) {
      return _.upperFirst(str.replace(/_/g, " "))
    },
    assignLocationModal(id, service_plan_name) {
      this.vEmit({ name: "ScheduleLoadLocation", data: { id, service_plan_name } })
    },
    titleCase(str = "") {
      return _.startCase(str.replace(/_/g, " "));
    },
    resetServerValidation() {
      this.serverValidation = true;
      this.serverValidationMessage = "Oops something went wrong...";
    },
    errors: getValMessage(valMessages)(validations)
  },
  computed: {
    ...mapGetters(['permissions']),
    filteredStaff: function() {
      if (
        !this.no_data.includes(this.massTechReassignData.selected_staff_id_from)
      ) {
        if (
          !this.no_data.includes(
            this.massTechReassignData.selected_staff_id_to
          ) &&
          this.massTechReassignData.selected_staff_id_to ===
            this.massTechReassignData.selected_staff_id_from
        ) {
          this.massTechReassignData.selected_staff_id_to = null;
        }
        return this.staff.filter(
          i => i.id !== this.massTechReassignData.selected_staff_id_from
        );
      } else {
        return this.staff;
      }
    }
  }
};
</script>
<style scoped>
/**tools table**/
.clients-wrap div.datatable.table {
  margin-bottom: 0%;
}

.dialog-heading {
  background-color: #efefef;
  padding: 10px;
}

.no-opacity {
  opacity: 0;
}

td a {
  text-decoration: none;
}

.clear-filters {
  text-transform: none;
  color: #00838F;
  cursor: pointer;
  text-decoration: underline;
  font-size: 14px;
}
</style>
